<template>
  <div>
    <div class="fixed">
      <!-- 筛选框 -->
      <div class="filter-date">
        <div class="filter-left">
          <div class="date" @click="showDate = true">
            {{ queryParam.quarter }} {{ queryParam.year }} <img src="/arrow_down.png" />
          </div>
          <div class="appeal">
            <div>DDI流向数据截止至：{{ maxBusinessDate.mtd_max_business_date }}</div>
            <div>月度流向数据截止至：{{ maxBusinessDate.ytd_max_business_date }}</div>
          </div>
        </div>
        <div class="filter-right">
          <div class="top">
            <div class="confirm" @click="handleConfirm" v-if="btnShow">确认</div>
            <div
              :class="{ filter: true, 'filter-non': !isFilter, 'filter-active': isFilter }"
              @click="showFilter = true"
            >
              <img src="/filter.png" v-if="!isFilter" />
              <img src="/filter_active.png" v-else />
            </div>
          </div>
          <div class="bottom">
            <van-button :class="['btn', showQty ? 'btn-active' : '']" :disabled="loading" @click="showQty = true"
              >数量</van-button
            >
            <van-button :class="['btn', !showQty ? 'btn-active' : '']" :disabled="loading" @click="showQty = false"
              >金额</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 预估达成 -->
    <div class="estimate-achieve">
      <div class="estimate-achieve-title">QTD预估达成</div>
      <div class="estimate-achieve-content">
        <div class="content-left">
          <div class="left">
            <div class="left-title">月度+预估{{ showQty ? '数量' : '金额' }}</div>
            <div class="left-content">
              {{ (showQty ? cardInfo.standardEstimateQty : cardInfo.standardEstimateAmount) | numberFormat(false) }}
            </div>
          </div>
          <div class="left">
            <div class="left-title">指标{{ showQty ? '数量' : '金额' }}</div>
            <div class="left-content">
              {{ (showQty ? cardInfo.targetQty : cardInfo.targetAmount) | numberFormat(false) }}
            </div>
          </div>
          <div class="left">
            <div class="left-title">月度+DDI{{ showQty ? '数量' : '金额' }}</div>
            <div class="left-content">
              {{ (showQty ? cardInfo.standardActualQty : cardInfo.standardActualAmount) | numberFormat(false) }}
            </div>
          </div>
        </div>
        <div class="content-right">
          <div class="mb10">
            <van-circle
              v-model="estimateSchedule"
              :stroke-width="60"
              color="#1EB195"
              layer-color="#F2F2F2"
              size="75px"
              :rate="estimateSchedule"
              :speed="100"
              :clockwise="false"
            >
              <template slot="default">
                <div class="schedule-text">
                  <div>
                    {{
                      (showQty ? cardInfo.estimateAchievementQty : cardInfo.estimateAchievementAmount)
                        | numberFormat(false, true)
                    }}
                  </div>
                  <div>预估达成</div>
                </div>
              </template>
            </van-circle>
          </div>
          <div>
            <van-circle
              v-model="actualSchedule"
              :stroke-width="60"
              color="#1EB195"
              layer-color="#F2F2F2"
              size="75px"
              :rate="actualSchedule"
              :speed="100"
              :clockwise="false"
            >
              <template slot="default">
                <div class="schedule-text">
                  <div>
                    {{
                      (showQty ? cardInfo.actualAchievementQty : cardInfo.actualAchievementAmount)
                        | numberFormat(false, true)
                    }}
                  </div>
                  <div>实际达成</div>
                </div>
              </template>
            </van-circle>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="list">
      <!-- 填写中卡片信息 -->
      <div class="fillIn-info" v-for="(item, index) in fillInList" :key="'fillIn-' + index" @click="viewDetail(item)">
        <!-- 标题 -->
        <div class="fillIn-info-title">
          <div class="content">
            <div class="text">
              <span>{{ item.ym }}</span> <span>{{ item.version }}</span>
            </div>
          </div>
          <div class="tag">填写中</div>
        </div>
        <!-- 内容信息 -->
        <div class="fillIn-info-content">
          <div class="fillIn-info-item">
            <div class="content-title">预估{{ showQty ? '数量' : '金额' }}(标准)</div>
            <div class="content-text">
              {{ (showQty ? item.standardEstimateQty : item.standardEstimateAmount) | numberFormat(false) }}
            </div>
          </div>
          <div class="fillIn-info-item">
            <div class="content-title">指标{{ showQty ? '数量' : '金额' }}</div>
            <div class="content-text">{{ (showQty ? item.targetQty : item.targetAmount) | numberFormat(false) }}</div>
          </div>
          <div class="fillIn-info-item">
            <div class="content-title">预估达成</div>
            <div class="content-text">
              {{ (showQty ? item.estimateAchievementQty : item.estimateAchievementAmount) | numberFormat(false, true) }}
            </div>
          </div>
        </div>
      </div>
      <div class="info-line"></div>
      <!-- 非填写中卡片信息 -->
      <div
        class="fillOut-info"
        v-for="(item, index) in fillOutList"
        :key="'fillOut-' + index"
        @click="viewDetail(item)"
      >
        <!-- 标题 -->
        <div class="fillOut-info-title">
          <div class="content">
            <div class="text">
              <span>{{ item.ym }}</span> <span>{{ item.version }}</span>
            </div>
          </div>
        </div>
        <!-- 内容信息 -->
        <div class="fillOut-info-content">
          <div class="fillOut-info-item">
            <div class="content-title">{{ item.showType | filterVersion }}{{ showQty ? '数量' : '金额' }}(标准)</div>
            <div class="content-text">
              <span v-if="showEstimate(item.showType)"> 
                {{ (showQty ? item.standardEstimateQty : item.standardEstimateAmount) | numberFormat(false) }}
              </span>
              <span v-else>
                {{ (showQty ? item.standardActualQty : item.standardActualAmount) | numberFormat(false) }}
              </span>
            </div>
          </div>
          <div class="fillOut-info-item">
            <div class="content-title">指标{{ showQty ? '数量' : '金额' }}</div>
            <div class="content-text">{{ (showQty ? item.targetQty : item.targetAmount) | numberFormat(false) }}</div>
          </div>
          <div class="fillOut-info-item">
            <div class="content-title">{{ item.showType | filterVersion }}达成</div>
            <div class="content-text">
              <span v-if="showEstimate(item.showType)">
                {{
                  (showQty ? item.estimateAchievementQty : item.estimateAchievementAmount) | numberFormat(false, true)
                }}
              </span>
              <span v-else>
                {{ (showQty ? item.actualAchievementQty : item.actualAchievementAmount) | numberFormat(false, true) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showFilter" round position="bottom" get-container="#app" :style="{ height: '80%' }">
      <div class="filter-title">筛选<img src="/filter_close.png" @click="showFilter = false" /></div>
      <div class="filter-box">
        <!-- 筛选框 -->
        <van-form>
          <van-row>
            <van-col span="24" class="input-title">Brand Group</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="brandGroup"
                placeholder="请选择Brand Group"
                @click="showBrandGroup = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="brandGroup" @click.stop="clearSelect('brandGroup')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">品牌</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="productLineName"
                placeholder="请选择品牌"
                @click="showProductLine = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="productLineId" @click.stop="clearSelect('productLineId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">Sales Group</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="productName"
                placeholder="请选择Sales Group"
                @click="showSalesGroup = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="productName" @click.stop="clearSelect('productName')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">NSD</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="nsdName"
                placeholder="请选择NSD"
                @click="showNsd = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="ahTerritoryId" @click.stop="clearSelect('ahTerritoryId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">RM</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="rmName"
                placeholder="请选择RM"
                @click="showRm = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="asmTerritoryId" @click.stop="clearSelect('asmTerritoryId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">DM</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="dmName"
                placeholder="请选择DM"
                @click="showDm = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="dsmTerritoryId" @click.stop="clearSelect('dsmTerritoryId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
          </van-row>

          <div class="filter-btn">
            <van-button class="btn" round block @click="reset">重置</van-button>
            <van-button class="btn" round block type="info" @click="search">应用</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <!-- 日期选择框 -->
    <van-popup v-model="showDate" round position="bottom" :style="{ height: '50%' }">
      <van-picker :item-height="60" show-toolbar :columns="yearQuarterList" @confirm="confirmDate" @cancel="showDate = false" />
      <!-- <van-datetime-picker
        v-model="currentDate"
        :max-date="maxYm"
        type="year-month"
        title="选择年月"
        @confirm="confirmDate"
        @cancel="cancelDate"
      /> -->
    </van-popup>
    <!-- Brand Group -->
    <van-popup v-model="showBrandGroup" position="bottom">
      <van-search v-model="brandGroupValue" @input="searchBrandGroup" placeholder="搜索Brand Group" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="brandGroupResultList"
        value-key="brandGroup"
        @confirm="confirmBrandGroup"
        @cancel="showBrandGroup = false"
      />
    </van-popup>
    <!-- 品牌 -->
    <van-popup v-model="showProductLine" position="bottom">
      <van-search v-model="productLineValue" @input="searchProductLine" placeholder="搜索品牌" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="productLineResultList"
        value-key="productLineName"
        @confirm="confirmProductLine"
        @cancel="showProductLine = false"
      />
    </van-popup>
    <!-- Sales Group -->
    <van-popup v-model="showSalesGroup" position="bottom">
      <van-search v-model="salesGroupValue" @input="searchSalesGroup" placeholder="搜索Sales Group" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="salesGroupResultList"
        @confirm="confirmSalesGroup"
        @cancel="showSalesGroup = false"
      />
    </van-popup>
    <!-- NSD -->
    <van-popup v-model="showNsd" position="bottom">
      <van-search v-model="nsdValue" @input="searchNsd" placeholder="搜索NSD" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="nsdList"
        value-key="ah_user_name"
        @confirm="confirmNsd"
        @cancel="showNsd = false"
      />
    </van-popup>
    <!-- RM -->
    <van-popup v-model="showRm" position="bottom">
      <van-search v-model="rmValue" @input="searchRm" placeholder="搜索RM" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="rmList"
        value-key="asm_user_name"
        @confirm="confirmRm"
        @cancel="showRm = false"
      />
    </van-popup>
    <!-- DM -->
    <van-popup v-model="showDm" position="bottom">
      <van-search v-model="dmValue" @input="searchDm" placeholder="搜索DM" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="dmList"
        value-key="dsm_user_name"
        @confirm="confirmDm"
        @cancel="showDm = false"
      />
    </van-popup>
    <EstimateDialog ref="estimateDialog" />
  </div>
</template>

<script>
// import Vue from 'vue'
import { getAction, postAction } from '@/api/manage'
import _ from 'lodash'
import moment from 'moment'
import EstimateDialog from './EstimateDialog.vue'

export default {
  components: {
    EstimateDialog,
  },
  data() {
    return {
      loading: false,
      refreshing: false,
      showDate: false, // 日期选择
      showFilter: false, // 显示筛选框
      showConfirmEstimate: false, // 显示确认预估弹框
      showQty: false, // 数量金额展示信息
      showProductLine: false, // 显示品牌
      showSalesGroup: false, // 显示Sales Group
      showBrandGroup: false, // 显示Brand Group
      showNsd: false, // 显示NSD
      showRm: false, // 显示Rm
      showDm: false, // 显示Dm
      isFilter: false, // 是否进行过搜索
      currentDate: new Date(),
      queryParam: {
        year: moment().format('YYYY'),
        quarter: null,
      },
      maxBusinessDate: {}, // 最大流向截止日期
      yearQuarterList: [
        // 第一列
        {
          values: [],
          defaultIndex: null,
        },
        // 第二列
        {
          values: ['Q1', 'Q2', 'Q3', 'Q4'],
          defaultIndex: null,
        },
      ],
      productLineId: null, // 品牌
      productLineName: null, // 品牌名称
      productLineValue: '', // 品牌搜索内容
      productLineList: [], // 品牌列表
      productLineResultList: [], // 品牌搜索结果列表
      productName: null, // Sales Group名称
      salesGroupValue: '', // Sales Group搜索内容
      salesGroupList: [], // Sales Group列表
      salesGroupResultList: [], // Sales Group搜索结果列表
      brandGroup: null, // Brand Group名称
      brandGroupValue: '', // Brand Group搜索内容
      brandGroupList: [], // Brand Group列表
      brandGroupResultList: [], // Brand Group搜索结果列表
      ahTerritoryId: null, // NSD
      nsdName: null, // NSD名称
      nsdValue: '', // NSD搜索内容
      nsdList: [], // NSD列表
      asmTerritoryId: null, // RM
      rmName: null, // RM名称
      rmValue: '', // RM搜索内容
      rmList: [], // RM列表
      dsmTerritoryId: null, // DM
      dmName: null, // DM名称
      dmValue: '', // DM搜索内容
      dmList: [], // DM列表
      schedule: 0, // 进度
      cardInfo: {}, // 卡片信息
      estimateSchedule: 0, // 预估达成
      actualSchedule: 0, // 实际达成
      fillInList: [], // 填写中卡片信息
      fillOutList: [], // 非填写中卡片信息
      btnShow: false, // 确认预估按钮显示判断
    }
  },
  filters: {
    filterVersion(val) {
      if (val  == 1 ) {
        return '实际'
      } else {
        return '预估'
      }
    },
  },
  computed: {
    maxYm() {
      return moment().toDate()
    },
  },
  watch: {
    // 'queryParam.year': {
    //   handler: function (val) {
    //     // 重新加载数据
    //     this.loading = true
    //     this.getProductLine() // 获取品牌
    //     this.getSalesGroup() // 获取Sales Group
    //     this.getBrandGroup() // 获取Brand Group
    //   },
    //   deep: true, //深度侦听
    // },
    showQty(val) {
      if (val) {
        this.estimateSchedule = Number(this.cardInfo.estimateAchievementQty)
        this.actualSchedule = Number(this.cardInfo.actualAchievementQty)
      } else {
        this.estimateSchedule = Number(this.cardInfo.estimateAchievementAmount)
        this.actualSchedule = Number(this.cardInfo.actualAchievementAmount)
      }
    },
  },
  mounted() {
    this.estimateBtnShow() // 确认预估按钮显示判断
    this.getDefaultYm() // 获取默认展示的年和季度
    this.getMaxBusinessDate() // 获取最大流向截止日期
  },
  methods: {
    // 判断是否是预估
    showEstimate(val) {
      // 1表示实际，2表示预估
      if (val == 1) {
        return false
      } else {
        return true
      }
    },
    // 获取默认展示的年和季度
    getDefaultYm() {
      getAction('/sip/estimate/overview/getQuarterlyStatisticsQueryCondition').then(res => {
        console.log('获取默认展示的年和季度------', res)
        if (res.success) {
          this.queryParam.year = res.result.year
          this.queryParam.quarter = res.result.quarter
          this.getYearRange() // 获取年份列表
          this.getCardInfo()
          this.getProductLine() // 获取品牌
          this.getSalesGroup() // 获取Sales Group
          this.getBrandGroup() // 获取Brand Group
          this.getNsd() // 获取NSD
          this.getRm() // 获取RM
          this.getDm() // 获取DM
        }
      })
    },
    // 获取最大流向截止日期
    getMaxBusinessDate() {
      getAction('/sip/estimate/overview/getMaxBusinessDate').then(res => {
        console.log('获取最大流向截止日期------', res)
        this.maxBusinessDate = res.result
      })
    },
    // 确认预估按钮显示判断
    estimateBtnShow() {
      postAction('/sip/estimate/overview/isEstimateButtonVisible').then(res => {
        this.btnShow = res.result.isVisible
      })
    },
    // 获取卡片信息
    getCardInfo() {
      let params = {
        year: this.queryParam.year,
        quarter: this.queryParam.quarter,
        productLineId: this.productLineId,
        productName: this.productName,
        brandGroup: this.brandGroup,
        ahTerritoryId: this.ahTerritoryId,
        asmTerritoryId: this.asmTerritoryId,
        dsmTerritoryId: this.dsmTerritoryId,
      }

      postAction('/sip/estimate/overview/mobile/qtyStatisticsByQtdAndMonth', params).then(res => {
        console.log('获取卡片信息------', res)
        if (res.success) {
          this.cardInfo = res.result.qtdVO
          this.estimateSchedule = Number(this.cardInfo.estimateAchievementAmount) // 预估达成
          this.actualSchedule = Number(this.cardInfo.actualAchievementAmount) // 实际达成
          this.fillInList = res.result.fillInList
          this.fillOutList = res.result.fillOutList
          this.loading = false
        } else {
          this.loading = false
          this.$toast(res.message)
        }
      })
    },
    // 确认预估按钮
    handleConfirm() {
      this.$refs.estimateDialog.edit()
    },
    // 选择日期
    confirmDate(val) {
      this.queryParam.year = val[0]
      this.queryParam.quarter = val[1]
      this.getCardInfo()
      this.getProductLine() // 获取品牌
      this.getSalesGroup() // 获取Sales Group
      this.getBrandGroup() // 获取Brand Group
      this.showDate = false
    },
    // 取消日期
    cancelDate() {
      this.showDate = false
    },
    // 选择品牌
    confirmProductLine(val) {
      console.log('选择品牌------', val)
      this.productLineId = val.productLineId
      this.productLineName = val.productLineName
      this.showProductLine = false
    },
    // 选择Sales Group
    confirmSalesGroup(val) {
      console.log('选择Sales Group------', val)
      this.productName = val
      this.showSalesGroup = false
    },
    // 选择Brand Group
    confirmBrandGroup(val) {
      console.log('选择Brand Group------', val)
      this.brandGroup = val.brandGroup
      this.showBrandGroup = false
    },
    // 选择NSD
    confirmNsd(val) {
      console.log('选择NSD------', val)
      this.ahTerritoryId = val.ah_territory_id
      this.nsdName = val.ah_user_name
      this.showNsd = false
    },
    // 选择RM
    confirmRm(val) {
      console.log('选择RM------', val)
      this.asmTerritoryId = val.asm_territory_id
      this.rmName = val.asm_user_name
      this.showRm = false
    },
    // 选择DM
    confirmDm(val) {
      console.log('选择DM------', val)
      this.dsmTerritoryId = val.dsm_territory_id
      this.dmName = val.dsm_user_name
      this.showDm = false
    },
    // 清空下拉框
    clearSelect(select) {
      if (select === 'productLineId') {
        this.productLineId = null
        this.productLineName = null
      } else if (select === 'productName') {
        this.productName = null
      } else if (select === 'brandGroup') {
        this.brandGroup = null
      } else if (select === 'ahTerritoryId') {
        this.ahTerritoryId = null
        this.nsdName = null
      } else if (select === 'asmTerritoryId') {
        this.asmTerritoryId = null
        this.rmName = null
      } else if (select === 'dsmTerritoryId') {
        this.dsmTerritoryId = null
        this.dmName = null
      }
    },
    // 搜索品牌
    searchProductLine: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.productLineResultList = this.productLineList.filter(item =>
        item.productLineName.toLowerCase().includes(keyword)
      )
    }, 500),
    // 搜索Sales Group
    searchSalesGroup: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.salesGroupResultList = this.salesGroupList.filter(item => item.toLowerCase().includes(keyword))
    }, 500),
    // 搜索Brand Group
    searchBrandGroup: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.brandGroupResultList = this.brandGroupList.filter(item => item.brandGroup.toLowerCase().includes(keyword))
    }, 500),
    // 搜索NSD
    searchNsd: _.debounce(function (val) {
      if (val) {
        this.getNsd(val)
      }
    }, 500),
    // 搜索RM
    searchRm: _.debounce(function (val) {
      if (val) {
        this.getRm(val)
      }
    }, 500),
    // 搜索DM
    searchDm: _.debounce(function (val) {
      if (val) {
        this.getDm(val)
      }
    }, 500),
    // 获取年份
    getYearRange() {
      const currentYear = new Date().getFullYear()
      const pastYears = 10 // 过去10年
      const futureYears = 10 // 未来10年
      this.yearQuarterList[0].values = Array.from(
        { length: pastYears + futureYears + 1 },
        (_, i) => currentYear - pastYears + i
      )
      this.yearQuarterList[0].defaultIndex =
        this.yearQuarterList[0].values.findIndex(v => v == this.queryParam.year) || 0
      this.yearQuarterList[1].defaultIndex =
        this.yearQuarterList[1].values.findIndex(v => v == this.queryParam.quarter) || 0
    },
    // 获取品牌下拉框
    getProductLine() {
      getAction('/sip/estimate/overview/getProductLineByYearAndQuarter', {
        year: this.queryParam.year,
        quarter: this.queryParam.quarter,
      }).then(res => {
        console.log('获取品牌数据------', res)
        this.productLineList = res.result
        this.productLineResultList = [...this.productLineList]
      })
    },

    // 获取Sales Group下拉框
    getSalesGroup() {
      getAction('/sip/estimate/detail/salesGroup', {
        year: this.queryParam.year,
        quarter: this.queryParam.quarter,
      }).then(res => {
        console.log('获取Sales Group数据------', res)
        this.salesGroupList = res.result
        this.salesGroupResultList = [...this.salesGroupList]
      })
    },
    // 获取Brand Group下拉框
    getBrandGroup() {
      getAction('/sip/estimate/overview/getBrandGroupByYearAndQuarter', {
        year: this.queryParam.year,
        quarter: this.queryParam.quarter,
      }).then(res => {
        console.log('获取Brand Group数据------', res)
        this.brandGroupList = res.result
        this.brandGroupResultList = [...this.brandGroupList]
      })
    },
    // 获取NSD下拉框
    getNsd(ah = null) {
      getAction('/sip/estimate/overview/getNSDByYearAndQuarter', {
        ah,
        year: this.queryParam.year,
        quarter: this.queryParam.quarter,
      }).then(res => {
        console.log('获取NSD数据------', res)
        this.nsdList = res.result
      })
    },
    // 获取RM下拉框
    getRm(rm = null) {
      getAction('/sip/estimate/overview/getRMByYearAndQuarter', {
        rm,
        year: this.queryParam.year,
        quarter: this.queryParam.quarter,
      }).then(res => {
        console.log('获取RM数据------', res)
        this.rmList = res.result
      })
    },
    // 获取DM下拉框
    getDm(dm = null) {
      getAction('/sip/estimate/overview/getDMByYearAndQuarter', {
        dm,
        year: this.queryParam.year,
        quarter: this.queryParam.quarter,
      }).then(res => {
        console.log('获取DM数据------', res)
        this.dmList = res.result
      })
    },
    // 跳转详情
    viewDetail(record) {
      this.$emit('viewDetail', record)
    },

    // 查询
    search() {
      // 重新加载数据
      this.loading = true
      this.showFilter = false
      if (
        this.productLineId ||
        this.productName ||
        this.brandGroup ||
        this.ahTerritoryId ||
        this.asmTerritoryId ||
        this.dsmTerritoryId
      ) {
        this.isFilter = true
      } else {
        this.isFilter = false
      }
      this.getCardInfo()
      // Vue.ls.set('queryParam', this.queryParam)
      // Vue.ls.set('filterDate', this.filterDate)
    },
    // 重置
    reset() {
      // this.queryParam = {}
      this.productLineId = null
      this.brandGroup = null
      this.ahTerritoryId = null
      this.asmTerritoryId = null
      this.dsmTerritoryId = null
      this.productName = null
      this.productLineName = null
      this.nsdName = null
      this.rmName = null
      this.dmName = null
      // Vue.ls.remove('queryParam')
      this.isFilter = false
      this.showFilter = false
      // 重新加载数据
      this.loading = true
      this.getCardInfo()
    },
  },
}
</script>

<style lang="less" scoped>
.mb10 {
  margin-bottom: 10px;
}
// 筛选框
.filter-date {
  width: 100%;
  min-height: 50px;
  // margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 25px 10px 10px;
  position: fixed;
  background-color: #f6f7fb;
  z-index: 999;
  .filter-left {
    .date {
      font-size: 20px;
      font-weight: 600;
      color: #555;
      display: flex;
      align-items: center;
      img {
        width: 10px;
        height: 7px;
        margin-left: 10px;
      }
    }
    .appeal {
      font-size: 12px;
      color: #7f7f7f;
      margin-top: 5px;
    }
  }
  .filter-right {
    .top {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
      .confirm {
        width: 50px;
        height: 30px;
        font-size: 12px;
        color: #fff;
        background: #28b2ef;
        border-radius: 15px;
        text-align: center;
        line-height: 30px;
        margin-right: 10px;
      }
    }
    .bottom {
      // 切换按钮样式
      .van-button {
        width: 50px;
        height: 25px;
        border-radius: 8px;
        color: #fff;
        background-color: #c0c0c0;
        border: none;
        padding: 5px;
      }
      .van-button:first-child {
        margin-right: -8px;
      }
      .btn-active {
        z-index: 999;
        background-color: #25b4f2;
      }
    }
  }
  .filter {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 15px;
      height: 15px;
    }
  }
  .filter-non {
    background: #fff;
  }
  .filter-active {
    background: #5cc0eb;
  }
}
.estimate-achieve {
  min-height: 180px;
  font-size: 12px;
  color: #4e7092;
  background: #fff;
  border-radius: 8px;
  position: relative;
  top: 100px;
  margin: 0 15px;
  padding: 5px 17px;
  margin-bottom: 15px;
  &-title {
    font-size: 15px;
    font-weight: 600;
  }
  &-content {
    display: flex;
    // align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    .content-left {
      width: 60%;
      display: flex;
      flex-wrap: wrap;
      // align-items: center;
      justify-content: space-between;
      margin-top: 5px;
      gap: 12px;
      .left {
        width: 45%;
        &-title {
          font-weight: 600;
          margin-bottom: 5px;
        }
      }
    }
    .content-right {
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-direction: column;
      margin-right: 20px;
      margin-top: -10px;
    }
    // 进度条文字样式
    .schedule-text {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      div:first-child {
        font-weight: 600;
      }
      div:last-child {
        font-size: 8px;
      }
    }
  }
}
// 列表
.list {
  margin-top: 20px;
  padding: 0 15px;
  padding-top: 90px;
  // 填写中卡片信息,非填写中卡片信息
  .fillIn-info,
  .fillOut-info {
    width: 100%;
    min-height: 110px;
    font-size: 12px;
    color: #4e7092;
    background: #fff;
    border-radius: 8px;
    padding: 10px 17px;
    padding-bottom: 0;
    margin-bottom: 15px;
    // 标题
    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .content {
        display: flex;
        align-items: center;
        .text {
          span:first-child {
            font-size: 15px;
            font-weight: 600;
            margin-right: 10px;
          }
        }
      }
      .tag {
        font-size: 10px;
        width: 60px;
        height: 24px;
        border-radius: 6px;
        text-align: center;
        line-height: 24px;
        background-color: #fff1cd;
        color: #edac55;
      }
    }
    // 内容信息
    &-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 15px;
      padding-right: 10px;
      .fillIn-info-item,
      .fillOut-info-item {
        width: 30%;
      }
      .fillIn-info-item:nth-child(2),
      .fillOut-info-item:nth-child(2) {
        padding-left: 16px;
      }
      .fillIn-info-item:last-child,
      .fillOut-info-item:last-child {
        width: 20%;
        padding-left: 12px;
      }

      .content-title {
        font-weight: 500;
        margin-bottom: 5px;
      }
    }
  }
  .fillIn-info {
    margin-bottom: 0;
  }
  // info分割线
  .info-line {
    height: 1px;
    background: #e1e2e6;
    margin: 12px 0;
  }
}

// 筛选框
.filter-box {
  margin-top: 65px;
  padding: 0 25px;
  padding-bottom: 80px;
}
.filter-title {
  width: 100%;
  height: 50px;
  color: #555;
  background: #fff;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  padding: 17px;
  z-index: 9999;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  border-bottom: 1px solid #f2f2f2;
  img {
    width: 14px;
    height: 14px;
  }
}
.input-title {
  font-size: 12px;
  color: #4e7092;
  margin-bottom: 10px;
}
.filter-input {
  width: 100%;
  height: 40px;
  font-size: 12px;
  border: 1px solid #aaa;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-icon {
  display: flex;
  align-items: center;
}
.filter-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 10px 20px;
  background-color: #fff;
  // margin-top: 28px;
  .btn {
    width: 140px;
    height: 43px;
    font-size: 13px;
    color: #4e7092;
    border-radius: 16px;
    background: #f2f2f2;
    line-height: 43px;
  }
  .van-button--info {
    background-color: #6fc3ff;
    color: #fff;
    border: none;
  }
}
</style>
